export default {
  get name(): string {
    return 'ExponentAmplitude';
  },
};
